import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import appLogo from '../../assets/images/logo.png';
import '../css/VersionAlert.css';

const VersionAlert = ({ 
  message, 
  onClose, 
  onClick,
  autoHideDuration = null  
}) => {
  return (
    <Snackbar
      open={true}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      className="version-snackbar"
    >
      <Alert 
        onClose={onClose}
        severity="info"
        className="version-alert"
        onClick={onClick}
        icon={false}
      >
        <div className="version-alert-content">
          <img src={appLogo} alt="App Logo" className="version-alert-logo" />
          <span className="version-alert-message">{message}</span>
        </div>
      </Alert>
    </Snackbar>
  );
};

export default VersionAlert; 